/**
 * Custom Graph Edge Component
 *
 * Displays a relationship edge in the knowledge graph with styling based on relation type
 */
import React, { memo } from 'react'
import { EdgeProps, getBezierPath, EdgeLabelRenderer, BaseEdge } from 'reactflow'
import { RelationType } from '@/types'

interface CustomEdgeData {
  relationType: RelationType
  weight?: number
  color: string
}

const CustomGraphEdge: React.FC<EdgeProps<CustomEdgeData>> = memo(({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  label,
  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: data?.color,
          strokeWidth: data?.weight ? data.weight * 3 : 2,
        }}
      />
      {label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <div
              className="px-2 py-1 rounded text-xs font-medium bg-white border shadow-sm"
              style={{
                borderColor: data?.color,
                color: data?.color,
              }}
            >
              {label}
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  )
})

CustomGraphEdge.displayName = 'CustomGraphEdge'

export default CustomGraphEdge
